import * as React from "react";
import { forwardRef } from "react";
const SvgSsAll = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.73529 10.629V2.78276H3.79412V10.629H2.73529ZM5.47059 13.4118V0H6.52941V13.4118H5.47059ZM0 7.87324V5.53853H1.05882V7.87324H0ZM8.20588 10.629V2.78276H9.26471V10.629H8.20588ZM10.9412 7.87324V5.53853H12V7.87324H10.9412Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgSsAll);
export { ForwardRef as ReactComponent };
